// @ts-nocheck
import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoCondensedDisplay, {
    AddressInfoCondensedDisplayStyles,
} from "@insite/content-library/Components/AddressInfoCondensedDisplay";
import DistanceDisplay, { DistanceUnitOfMeasure } from "@insite/content-library/Components/DistanceDisplay";
import GoogleMapsDirectionLink from "@insite/content-library/Components/GoogleMapsDirectionLink";
import LocationContentLink from "@insite/content-library/Components/LocationContentLink";
import LocationPagination from "@insite/content-library/Components/LocationPagination";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import InlineFormButton from "@store/Library/Components/Toolkit/InlineFormButton";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { inlineFormGap, inlineFormWithLabelProps } from "@store/Themes/common/props/inlineForm";
import { locationProps } from "@store/Themes/common/props/location";
import useGoogleMapMarkerIconByType from "@toolkit/Framework/Common/Hooks/googleMap/useGoogleMapMarkerIconByType";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
/* Starter Custom Code - End */

interface OwnProps {
    extendedStyles?: LocationSearchFormStyles;
    onSearch: (searchGeoLocationFilter: string, searchLocationFilter: string, radiusSearch?: number) => void;
    onLocationSelected: (location: LocationModel) => void;
    locationKnown: boolean;
    showSelectedLocation: boolean;
    getLocationNumberFromPagination: (locationIndex: number) => number;
    openLocationContentDisplay: (location: LocationModel) => void;
    resultCount: number;
    locationSearchFilter: string;
    radiusSearchFilter?: number;
    geoLocationSearchText: string;
    showGeoLocationErrorMessage: boolean;
    geoLocationErrorMessage: React.ReactNode;
    isLoading: boolean;
    distanceUnitOfMeasure: DistanceUnitOfMeasure;
    setDistanceUnitOfMeasure: (uom: DistanceUnitOfMeasure) => void;
    locations: LocationModel[];
    locationsPagination: PaginationModel | undefined;
    setPage: (page: number) => void;
    setPageSize: (pageSize: number) => void;
    siteMessageResultsErrorMessage: React.ReactNode;
    // Starter Custom Code
    isForm?: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    settings: getSettingsCollection(state),
});

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface LocationSearchFormStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    form?: InjectableCss;
    searchContainer?: InjectableCss;
    searchInputRow?: InjectableCss;
    searchInputGridContainer?: GridContainerProps; // Starter Custom Code
    searchGeoLocationGridItem?: GridItemProps;
    searchGeoLocationText?: TextFieldPresentationProps;
    searchLocationsGridItem?: GridItemProps;
    searchLocationsText?: TextFieldPresentationProps;
    searchRadiusGridItem?: GridItemProps;
    searchRadiusText?: TextFieldPresentationProps;
    searchButtonGridItem?: GridItemProps;
    searchButton?: ButtonPresentationProps;
    searchResultsTextGridItem?: GridItemProps;
    searchResultsText?: TypographyPresentationProps;
    distanceUnitOfMeasureGridItem?: GridItemProps;
    distanceUnitOfMeasureRadioGroup?: RadioGroupProps;
    distanceUnitOfMeasureImperialRadio?: RadioComponentProps;
    distanceUnitOfMeasureMetricRadio?: RadioComponentProps;
    siteMessageGridItem?: GridItemProps;
    siteMessageGeocodeErrorText?: TypographyPresentationProps;
    siteMessageResultsErrorText?: TypographyPresentationProps;
    searchResultGridItem?: GridItemProps;
    searchResultRow?: InjectableCss;
    searchResultGridContainer?: GridContainerProps;
    searchResultLocationDetailsGridContainer?: GridContainerProps;
    searchResultDisplayNumberGridItem?: GridItemProps;
    locationDisplayNumberText?: TypographyPresentationProps;
    searchResultLocationGridItem?: GridItemProps;
    locationNameText?: TypographyPresentationProps;
    locationNameLink?: LinkPresentationProps;
    searchResultAddressInfoOffsetGridItem?: GridItemProps;
    searchResultAddressInfoGridItem?: GridItemProps;
    locationAddressInfoCondensed?: AddressInfoCondensedDisplayStyles;
    searchResultLinksAndDistanceContainer?: GridContainerProps;
    searchResultPhoneOffsetGridItem?: GridItemProps;
    searchResultPhoneGridItem?: GridItemProps;
    searchResultPhoneLink?: LinkPresentationProps;
    searchResultLinksOffsetGridItem?: GridItemProps;
    searchResultContentGridItem?: GridItemProps;
    locationContentLink?: LinkPresentationProps;
    searchResultGoogleMapsDirectionLinkGridItem?: GridItemProps;
    locationGoogleMapsDirectionLink?: LinkPresentationProps;
    searchResultDistanceGridItem?: GridItemProps;
    locationDistanceDisplayText?: TypographyPresentationProps;
    searchResultDividerGridItem?: GridItemProps;
    searchResultDivider?: InjectableCss;
    paginationRow?: GridItemProps;
    pagination?: PaginationPresentationProps;
    // Starter Custom Code
    searchResultsHeader?: InjectableCss;
    locationWrapper?: InjectableCss;
    locationInfoWrapper?: InjectableCss;
    locationNameWrapper?: InjectableCss;
    locationAddressWrapper?: InjectableCss;
    locationActionsWrapper?: InjectableCss;
    locationDetailsLink?: LinkPresentationProps;
}

export const locationSearchFormStyles: LocationSearchFormStyles = {
    form: locationProps.form,
    searchContainer: inlineFormWithLabelProps.wrapper,
    searchGeoLocationText: mergeProps<LocationSearchFormStyles["searchGeoLocationText"]>(
        inlineFormWithLabelProps.field,
        {
            cssOverrides: {
                formField: css`
                    flex-grow: 9999;
                    width: 100%;

                    ${breakpoint("lg")} {
                        width: auto;
                        max-width: calc(50% - ${inlineFormGap} / 2);
                    }
                `,
            },
        },
    ),
    searchLocationsText: inlineFormWithLabelProps.field,
    searchRadiusText: inlineFormWithLabelProps.field,
    searchButton: mergeProps<LocationSearchFormStyles["searchButton"]>(inlineFormWithLabelProps.button, {
        css: css`
            width: 100%;

            ${breakpoint("md")} {
                width: auto;
            }
        `,
    }),
    searchResultsHeader: locationProps.resultsHeader,
    searchResultsText: locationProps.resultsText,
    distanceUnitOfMeasureRadioGroup: locationProps.distanceRadioGroup,
    siteMessageResultsErrorText: locationProps.noResults,
    siteMessageGeocodeErrorText: locationProps.noResults,
    locationWrapper: locationProps.wrapper,
    locationInfoWrapper: locationProps.infoWrapper,
    locationNameWrapper: locationProps.nameWrapper,
    locationNameText: {
        ...locationProps.nameText,
        forwardAs: "h2",
    },
    locationNameLink: locationProps.nameLink,
    locationDistanceDisplayText: locationProps.distanceText,
    locationAddressWrapper: locationProps.addressWrapper,
    locationActionsWrapper: locationProps.actionsWrapper,
    locationDetailsLink: locationProps.actionLink,
    locationGoogleMapsDirectionLink: locationProps.actionLink,
    locationContentLink: locationProps.actionLink,
};

const StyledForm = getStyledWrapper("form");
// Starter Removed - StyledHr

// Starter Removed - Container
// Starter Removed - ContainerCell

const LocationSearchForm: React.FC<Props> = ({
    extendedStyles,
    onSearch,
    onLocationSelected,
    locationKnown,
    getLocationNumberFromPagination,
    openLocationContentDisplay,
    resultCount,
    locationSearchFilter,
    radiusSearchFilter,
    geoLocationSearchText,
    showGeoLocationErrorMessage,
    geoLocationErrorMessage,
    isLoading,
    distanceUnitOfMeasure,
    setDistanceUnitOfMeasure,
    locations,
    locationsPagination,
    setPage,
    setPageSize,
    siteMessageResultsErrorMessage,
    // Starter Custom Code
    isForm,
}) => {
    const styles = useMergeProps(locationSearchFormStyles, extendedStyles); // Starter Custom Code
    const [searchLocationFilter, setSearchLocationFilter] = React.useState(locationSearchFilter);
    const [searchRadiusFilter, setSearchRadiusFilter] = React.useState(radiusSearchFilter);
    const [searchGeoLocationFilter, setSearchGeoLocationFilter] = React.useState(geoLocationSearchText);
    /* Starter Custom Code - Start */
    const [radiusSearch, setRadiusSearch] = React.useState("");
    const MarkerIcon = useGoogleMapMarkerIconByType("LOCATION");
    /* Starter Custom Code - End */
    React.useEffect(() => {
        setSearchLocationFilter(locationSearchFilter);
    }, [locationSearchFilter]);
    React.useEffect(() => {
        setSearchRadiusFilter(radiusSearchFilter);
    }, [radiusSearchFilter]);
    React.useEffect(() => {
        setSearchGeoLocationFilter(geoLocationSearchText);
    }, [geoLocationSearchText]);

    const handleDistanceUnitOfMeasureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as DistanceUnitOfMeasure;
        setDistanceUnitOfMeasure(value);
    };

    const generateOpenLocationContentFor = (location: LocationModel) => {
        return () => openLocationContentDisplay(location);
    };

    const generateLocationSelectClickHandler = (
        event: React.MouseEvent<Element, MouseEvent>,
        location: LocationModel,
    ) => {
        event.preventDefault();
        onLocationSelected(location);
    };

    const isNotFinalResult = (resultIndex: number) => {
        if (!locationsPagination) {
            return false;
        }
        return locationsPagination.pageSize > resultIndex + 1;
    };
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!isLoading) {
            locationsPagination && setPage(1);
            onSearch(searchGeoLocationFilter, searchLocationFilter, searchRadiusFilter);
        }
    };
    const handleSearchGeoLocationChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchGeoLocationFilter(event.target.value);
    };
    /* Starter Custom Code - Start */
    const handleSearchGeoLocationBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.value) {
            setSearchGeoLocationFilter(geoLocationSearchText);
        }
    };
    /* Starter Custom Code - End */
    const handleSearchLocationsChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchLocationFilter(event.target.value);
    };
    const handleSearchRadiusChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchRadiusFilter(Number(event.target.value));
        setRadiusSearch(event.target.value); // Starter Custom Code
    };

    return (
        <StyledForm {...styles.form} onSubmit={handleSubmit} noValidate>
            {isForm /* Starter Custom Code */ ? (
                <StyledWrapper {...styles.searchContainer} /* Starter Custom Code */>
                    <TextField
                        id="searchGeoLocation"
                        {...styles.searchGeoLocationText}
                        label={translate("Search by Postal Code, City, Province or Country")} // Starter Custom Code
                        // Valech Removed - required
                        value={searchGeoLocationFilter}
                        onChange={handleSearchGeoLocationChanged}
                        onBlur={handleSearchGeoLocationBlur} // Starter Custom Code
                        // Starter Removed - placeholder
                        data-test-selector="locationSearchForm_searchGeoLocation"
                        error={showGeoLocationErrorMessage ? geoLocationErrorMessage : undefined}
                    />
                    <TextField
                        id="searchLocations"
                        {...styles.searchLocationsText}
                        label={translate("Search for Location")}
                        value={searchLocationFilter}
                        onChange={handleSearchLocationsChanged}
                        // Starter Removed - placeholder
                        data-test-selector="locationSearchForm_searchLocations"
                    />
                    <TextField
                        id="searchRadius"
                        {...styles.searchRadiusText}
                        label={translate("Search Radius ({0})", translate("Miles"))} // Starter Custom Code
                        value={radiusSearch} // Starter Custom Code
                        onChange={handleSearchRadiusChanged}
                        type="number"
                        min={0}
                        // Starter Removed - placeholder
                    />
                    <InlineFormButton
                        {...styles.searchButton}
                        type="submit"
                        data-test-selector="locationSearchForm_searchButton"
                    >
                        {translate("Search")}
                    </InlineFormButton>
                </StyledWrapper>
            ) : (
                <>
                    <StyledWrapper {...styles.searchResultsHeader} /* Starter Custom Code */>
                        <Typography {...styles.searchResultsText}>
                            {/* Starter Custom Code - Start */}
                            {(resultCount === 1 ? translate("{0} Result") : translate("{0} Results")).replace(
                                "{0}",
                                `${resultCount}`,
                            )}
                            {/* Starter Custom Code - End */}
                        </Typography>
                        <RadioGroup
                            {...styles.distanceUnitOfMeasureRadioGroup}
                            id="distanceUoM"
                            name="distanceUoM"
                            value={distanceUnitOfMeasure}
                            onChangeHandler={handleDistanceUnitOfMeasureChange}
                            label={translate("Select distance unit")} // Starter Custom Code
                        >
                            <Radio {...styles.distanceUnitOfMeasureImperialRadio} value="Imperial">
                                {translate("Miles")}
                            </Radio>
                            <Radio {...styles.distanceUnitOfMeasureMetricRadio} value="Metric">
                                {translate("Kilometers")}
                            </Radio>
                        </RadioGroup>
                    </StyledWrapper>
                    {!isLoading && !locationKnown && geoLocationSearchText.length > 0 && (
                        <Typography {...styles.siteMessageGeocodeErrorText}>
                            {siteMessage("PickUpLocation_GeocodeErrorMessage")}
                        </Typography>
                    )}
                    {!isLoading && locationKnown && locations.length === 0 && siteMessageResultsErrorMessage && (
                        <Typography
                            {...styles.siteMessageResultsErrorText}
                            data-test-selector="locationSearchForm_siteErrorMessage"
                        >
                            {siteMessageResultsErrorMessage}
                        </Typography>
                    )}
                    {isLoading && locations.length === 0 && <Loader /> /* Starter Custom Code */}
                    {locations.map((location, index) => {
                        const resultNumberText = getLocationNumberFromPagination(index).toString(); // Starter Custom Code
                        return (
                            <StyledWrapper
                                key={location.id}
                                {...styles.locationWrapper}
                                data-test-selector="locationSearchForm_location"
                                data-test-key={`${location.id}`}
                            >
                                {/* Starter Custom Code - Start */}
                                <Typography {...styles.locationDisplayNumberText}>
                                    <VisuallyHidden>{translate("Result {0}", `${resultNumberText}`)}</VisuallyHidden>
                                    <StyledWrapper aria-hidden="true">
                                        <MarkerIcon text={resultNumberText} />
                                    </StyledWrapper>
                                </Typography>
                                <StyledWrapper {...styles.locationInfoWrapper}>
                                    <StyledWrapper {...styles.locationNameWrapper}>
                                        <Typography {...styles.locationNameText}>
                                            <Link
                                                {...styles.locationNameLink}
                                                onClick={(event: React.MouseEvent<Element, MouseEvent>) =>
                                                    generateLocationSelectClickHandler(event, location)
                                                }
                                                data-test-selector="findLocationModal_locationSelect"
                                                data-marker-number={index + 1} // Starter Custom Code
                                            >
                                                {location.name}
                                            </Link>
                                        </Typography>
                                        <DistanceDisplay
                                            {...styles.locationDistanceDisplayText}
                                            distance={location.distance}
                                            unitOfMeasure={distanceUnitOfMeasure}
                                        />
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.locationAddressWrapper}>
                                        <AddressInfoCondensedDisplay
                                            {...styles.locationAddressInfoCondensed}
                                            {...location}
                                        />
                                        {location.phone && (
                                            <Link
                                                href={`tel:${location.phone}`}
                                                {...styles.searchResultPhoneLink}
                                                target="_blank"
                                            >
                                                {location.phone}
                                            </Link>
                                        )}
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.locationActionsWrapper}>
                                        <Link
                                            {...styles.locationDetailsLink}
                                            onClick={(event: React.MouseEvent<Element, MouseEvent>) =>
                                                generateLocationSelectClickHandler(event, location)
                                            }
                                        >
                                            {translate("More Details")}
                                        </Link>
                                        {location.htmlContent && (
                                            <LocationContentLink
                                                {...styles.locationContentLink}
                                                location={location}
                                                onOpenLocationContent={generateOpenLocationContentFor(location)}
                                            />
                                        )}
                                        <GoogleMapsDirectionLink
                                            {...styles.locationGoogleMapsDirectionLink}
                                            {...location}
                                        />
                                    </StyledWrapper>
                                </StyledWrapper>
                                {/* Starter Custom Code - End */}
                            </StyledWrapper>
                        );
                    })}
                    <LocationPagination
                        {...styles.pagination}
                        locations={locations}
                        locationsPagination={locationsPagination}
                        setPage={setPage}
                        setPageSize={setPageSize}
                    />
                </>
            )}
        </StyledForm>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSearchForm);
